import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-admin-my-profile',
  templateUrl: './admin-my-profile.component.html',
  styleUrls: ['./admin-my-profile.component.sass'],
  standalone: false
})
export class AdminMyProfileComponent implements OnInit {

  constructor() { }
  title = 'My Profile';
  ngOnInit() {
  }

}
